var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 9.5H20M9 4.5V7.5M15 4.5V7.5M4 6H20V18H4V6Z","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Calendar.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Calendar;

Calendar.default = Calendar;
